import React, { useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import { Loader } from '../Common/Loader';
import { loginApi } from '../service/authentication';

const Login = () => {
    const navigate = useNavigate()
    const[loader,setLoader]=useState(false)
    const [formInput,setForminput]=useState({
        login_type:"email"
    })
    const handleInput =(e)=>{
        const {name,value} = e.target;
        setForminput({...formInput,[name]:value})
    }
    useEffect(()=>{
   if(localStorage.getItem("access_token")){
    navigate("/")
   }
    },[])

    const handleLogin =(e)=>{
        e.preventDefault()
        let data = formInput
        setLoader(true)
        loginApi(data).then((res)=>{
            console.log("Full login response:", res);
            const responseData = res?.data;
            
            // Check if login was successful
            if (responseData?.status === false) {
                alert(responseData?.message || "Login failed");
                setLoader(false);
                return;
            }
            
            // Try to get token from various possible locations
            const token = responseData?.access_token || responseData?.token || responseData?.data?.access_token;
            
            if (token) {
                localStorage.setItem("access_token", token);
                window.location.href="/";
            } else {
                console.log("Login response data:", responseData);
                alert("Login successful but no token received. Check console for response.");
            }
            setLoader(false)
        }).catch((err)=>{
            setLoader(false)
            console.log("Login error:", err)
            alert(err?.response?.data?.message || err?.response?.data?.detail || "Internal server error")
        })
    }
  return (
    <>
    {loader?<Loader/>:null}
        <div className='login'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-2"></div>
                    <div className="col-lg-6 col-md-8 login-box">
                        <div className="col-lg-12 login-key">
                            <i className="fa fa-key" aria-hidden="true"></i>
                        </div>
                        <div className="col-lg-12 login-title">
                            ADMIN PANEL
                        </div>

                        <div className="col-lg-12 login-form">
                            <div className="col-lg-12 login-form">
                                <form>
                                    <div className="form-group">
                                        <label className="form-control-label">USERNAME</label>
                                        <input name="email" type="text" className="form-control" onChange={handleInput}/>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-control-label">PASSWORD</label>
                                        <input name="password" type="password" className="form-control"  onChange={handleInput} />
                                    </div>

                                    <div className="col-lg-12 loginbttm">
                                        <div className="col-lg-6 login-btm login-text">
                                        </div>
                                        <div className="col-lg-6 login-btm login-button">
                                            <button type="submit" className="btn btn-outline-primary" onClick={handleLogin}>LOGIN</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Login